





























import { Component, Vue } from "vue-property-decorator";
import { Button, Icon,Field } from "vant";
@Component({
  name: "FailReason",
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Field.name]: Field
  }
})
export default class FailReasonData extends Vue {

  currentFailReasonList: any = [];
  created(){
	(this as any).getFailInfo();
  }
  getFailInfo(){
	 (this as any).$apis.getFailInfo().then(res => {
		 (this as any).currentFailReasonList = res.userinfo_pass_reason
	 });
  }
  handleNext(){
	 (this as any).$router.push({path:'/open-account/accountProfile',query:{isEdit:true}})
  }

}
